module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "music-playlist",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "music-playlist-header"
  }, [_vm._v("\n    播放列表\n    "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.items.length > 0),
      expression: "items.length > 0"
    }],
    staticClass: "clear-btn",
    attrs: {
      "title": "清空"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.confirmDialog = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("delete")])], 1)]), _vm._v(" "), (_vm.items.length === 0) ? _c('div', {
    staticClass: "empty-playlist-tips"
  }, [_vm._v("播放列表是空的")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "music-playlist-list"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      key: item.id,
      class: {
        current: _vm.currentMusicItem && _vm.currentMusicItem.id === item.id
      },
      on: {
        "dblclick": function($event) {
          _vm.playMusic(item)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.ar.map(function (e) { return e.name; }).join(' / ')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("parseDuration")(item.dt)))])])
  })), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.confirmDialog),
      callback: function($$v) {
        _vm.confirmDialog = $$v
      },
      expression: "confirmDialog"
    }
  }, [_c('v-card', {
    staticClass: "grey darken-3 white--text"
  }, [_c('v-card-text', [_vm._v("确认要清空播放列表吗？")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "round": "",
      "dark": "",
      "error": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.clear($event)
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "round": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.confirmDialog = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da8343ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MusicPlaylist.vue
// module id = 151
// module chunks = 1